import { render, staticRenderFns } from "./SSSEmployeeContribution.vue?vue&type=template&id=53668ce6"
import script from "./SSSEmployeeContribution.vue?vue&type=script&lang=js"
export * from "./SSSEmployeeContribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports